import fetch from '../utils/fetch'

export function getOAuthList (query) {
  return fetch({
    url: '/third/oauth',
    method: 'get',
    params: query
  })
}

export function createOAuth (query) {
  return fetch({
    url: '/third/oauth',
    method: 'post',
    data: query
  })
}

export function updateOAuth (query) {
  return fetch({
    url: '/third/oauth',
    method: 'put',
    data: query
  })
}

export function delOAuth (id) {
  return fetch({
    url: '/third/oauth/' + id,
    method: 'delete'
  })
}



// WEBPACK FOOTER //
// ./src/api/thirdoauth.js